import React from "react";
import { Card, Typography } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import styles from "./InfoDisplayLog.module.css";
import { TContext } from "../../types/config";
import DateUtils from "../../utils/date";

const { Text } = Typography;

interface InfoDisplayLogProps {
  message: string;
  timestamp: Date;
  context: TContext;
  stageName?: string;
}

const InfoDisplayLog: React.FC<InfoDisplayLogProps> = ({
  message,
  timestamp,
  context,
  stageName,
}) => {
  return (
    <Card className={styles.logCard} bodyStyle={{ padding: 0 }}>
      <Text className={styles.logTitle}>{stageName }</Text>
      <div className={styles.logHeader}>
        <InfoCircleOutlined className={styles.logIcon} />
        <Text className={styles.logMessage}>{message}</Text>
      </div>
      <div className={styles.logFooter}>
        <Text className={styles.logTimestamp}>
          {DateUtils.format(timestamp, context?.user?.dateFormat, true)}
        </Text>
      </div>
    </Card>
  );
};

export default InfoDisplayLog;
